export var ScreenWidth;
(function (ScreenWidth) {
    ScreenWidth["ExtraExtraSmall"] = "ExtraExtraSmall";
    ScreenWidth["ExtraSmall"] = "ExtraSmall";
    ScreenWidth["Small"] = "Small";
    ScreenWidth["Medium"] = "Medium";
    ScreenWidth["Large"] = "Large";
    ScreenWidth["ExtraLarge"] = "ExtraLarge";
    ScreenWidth["ExtraExtraLarge"] = "ExtraExtraLarge";
})(ScreenWidth || (ScreenWidth = {}));
export var ScreenHeight;
(function (ScreenHeight) {
    ScreenHeight["Small"] = "Small";
    ScreenHeight["Large"] = "Large";
})(ScreenHeight || (ScreenHeight = {}));
